import { computed } from '@ember/object';
import XZoomAccuracyBase from './x-zoom-accuracy-base';

export default class XZoomAccuracyClosing extends XZoomAccuracyBase {
  @computed('ticksWithLimits', 'zoomSettings') get enclosingTicks() {
    var base = this; // To specify which are declared in the base class
    var xTicks = base.get('ticksWithLimits');
    var zoomSettings = base.get('zoomSettings');
    var result = null;

    for (var i = 0; i < xTicks.length; i++) {
      var item = xTicks[i];
      if (item.x >= zoomSettings.x + zoomSettings.width && !result) {
        result = {};
        result.previousTick = xTicks[i - 1];
        result.nextTick = item;
        result.index = i;
      }
    }
    return result;
  }

  @computed('enclosingTicks', 'zoomSettings', 'pxBetweenTicks') get zoomCoverage() {
    var base = this; // To specify which are declared in the base class
    var enclosingTicks = this.enclosingTicks;
    var zoomSettings = base.get('zoomSettings');
    var pxBetweenTicks = parseFloat(base.get('pxBetweenTicks'));
    var coveredArea = zoomSettings.x + zoomSettings.width - enclosingTicks.previousTick.x;
    var percentage = coveredArea / pxBetweenTicks;
    return percentage;
  }

  @computed('zoomCoverage', 'previousTickValue', 'hzBetweenTicks') get actualEdgeValue() {
    var base = this; // To specify which are declared in the base class
    var zoomCoverage = parseFloat(base.get('zoomCoverage'));
    var previousTickValue = parseFloat(base.get('previousTickValue'));
    var valueDiffBetweenTicks = parseFloat(base.get('valueDiffBetweenTicks'));
    var result = previousTickValue + valueDiffBetweenTicks * zoomCoverage;
    return result;
  }
}
